import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { default as useUploadDocument } from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useDocumentListingQuery,
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import React, { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { AssetsRegistrationDepreciationDetailContent } from './AssetsRegistrationDepreciationDetailContent'
import { AssetsRegistrationDetailContent } from './AssetsRegistrationDetailContent'
import { AssetsRegistrationUsedDepartmentDetailContent } from './AssetsRegistrationUsedDepartmentDetailContent'

export const AssetsRegistrationDetail = (props: any) => {
  let history = useHistory()
  const { mode } = props
  const { CompanyID, AssetsRegistrationID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    clearErrors,
  } = useForm<any>()
  const [audioInput, setAudioInput] = useState('')
  const [record, setRecord] = useState(false)
  const [text, setText] = useState(mode === 'add' ? '' : editData?.remark)
  const [singleRemark, setSingleRemark] = useState(null)
  const handleSingleRemark = remark => {
    setSingleRemark(remark)
  }

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  let itemData
  itemData = editData

  const {
    files,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
    setFiles,
  } = useUploadDocument()

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const {
    loading: docLoading,
    data: { DocumentListing } = { DocumentListing: [] },
  } = useDocumentListingQuery({
    fetchPolicy: 'network-only',
    variables: {
      refID: AssetsRegistrationID,
    },
    onCompleted: data => {
      handleEditUpload(data?.DocumentListing)
      previewFiles.push(...data?.DocumentListing?.map(x => x?.fileURL))
    },
  })

  return (
    <>
      {docLoading && <Loading />}
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/assets-registration`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Fixed Assets' },
          { name: 'Assets Registration', current: true },
        ]}
        rightRouteSegments={[{ name: `Approved`, current: true }]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {itemData?.asset_card_no}
            </span>
          </span>
        }
        // rightText={<span className="c-orange">{itemData?.asset_card_no}</span>}
        infoLine={
          <div
            className="text-overflow"
            style={{ fontSize: '11px', fontWeight: 'bold', width: '270px' }}
          >
            {itemData?.Category?.name}
          </div>
        }
        rightInfoLine={
          <span className="desc c-orange">
            {itemData?.base_original_amount}
          </span>
        }
      />
      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <AssetsRegistrationDetailContent
            listEl={itemData}
            documentListing={DocumentListing}
            listStatus={itemData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>

        <CardContents
          section={{
            header: { title: 'Depreciation' },
          }}
        >
          <AssetsRegistrationDepreciationDetailContent
            listDepreciation={{
              Method: itemData?.DepreciationMethod?.name || '-',
              StartYear: itemData?.depreciation_start_year || '-',
              StartPeriod: itemData?.depreciation_start_period || '-',
              AccDepreciationAmount:
                itemData?.opening_accumulated_depreciation || 0,
              UsefulLife: itemData?.opening_depreciation_useful_life || 0,
              UtilizedUsefulLife:
                itemData?.depreciation_utilized_useful_life || 0,
              AccRevaluationAmount:
                itemData?.depreciation_revaluation_amount || 0,
              AccProvisionImpairment:
                itemData?.depreciation_provision_impairment || 0,
              AccReversalImpairment:
                itemData?.depreciation_reversal_impairment || 0,
            }}
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Used Department',
            },
          }}
        >
          <AssetsRegistrationUsedDepartmentDetailContent
            listUsedDepartment={itemData?.UsedDepartment}
          />
        </CardContents>
      </ContentWrapper>
    </>
  )
}
